/**
 * Agence'O - oraga-header-menu
 * @author Axel Baron (Agence'O)
 * @created 21/05/2019
 */

(function ($) {

  $(document).on('click', '.js-orga-menu-trigger', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $('.orga-header__menu').toggleClass('open');
  });

}(jQuery));
